import {
	Badge as BadgeIcon,
	Business as BusinessIcon,
	Cake as CakeIcon,
	Email as EmailIcon,
	Key as KeyIcon,
	KeyboardDoubleArrowRight as KeyboardDoubleArrowRightIcon,
	Person as PersonIcon,
} from '@mui/icons-material'

import { Tooltip } from '@mui/material'

import ErrorBoundary from '../ErrorBoundary'
import EditableField from '../ui/EditableField'

import {
	formatPhoneNumber,
} from '../../services/scout'
import { renderCRMFeatures } from '../../services/utils'

import ConversationAvatar from './ConversationAvatar'

const ConversationProfileSidebar = ({
	enterprise,
	selectedConversation,
	contact,
	getStableConversationTitle,
	onClose,
	onSaveName,
	onSaveEnterprise,
	onSaveEmail,
	onSaveBirthday,
	onSaveCpf,
	onSaveCustomerCode,
}) => {
	return (
		<aside className="scout-panel scout-panel--sidebar">
			<div className="scout-panel__heading">
				<h2>
					<PersonIcon />
					Perfil do contato
				</h2>
				<Tooltip title="Recolher">
					<button
						type="button"
						className="scout-icon-button"
						onClick={onClose}
					>
						<KeyboardDoubleArrowRightIcon />
					</button>
				</Tooltip>
			</div>

			{renderCRMFeatures(enterprise)
				? <div className="profile-panel">
					<div className="profile-panel--avatar">
						<ConversationAvatar conversation={selectedConversation} displayName={getStableConversationTitle(selectedConversation)} />
					</div>
					<span style={{ fontSize: '1.25rem' }} className={!contact?.name ? 'profile-panel--name empty' : 'profile-panel--name'}>
						<EditableField
							value={contact?.name}
							placeholder="Clique para adicionar um nome"
							onSave={onSaveName}
						/>
					</span>
					<div className="profile-panel--telephone">
						{formatPhoneNumber(selectedConversation.phone_num)}
					</div>
					<div className="profile-panel--fields">
						<div>
							<span><BusinessIcon />Empresa</span>
							<span className={!contact?.contact_enterprise ? 'empty' : ''}>
								<EditableField
									type="enterprise"
									label={contact?.enterprise_name}
									value={contact?.contact_enterprise}
									onSave={onSaveEnterprise}
								/>
							</span>
						</div>
						<div>
							<span><EmailIcon />E-mail</span>
							<span className={!contact?.email ? 'empty' : ''}>
								<EditableField
									type="email"
									value={contact?.email}
									onSave={onSaveEmail}
								/>
							</span>
						</div>
						<div>
							<span><CakeIcon />Aniversário</span>
							<span className={!contact?.birthday ? 'empty' : ''}>
								<EditableField
									type="date"
									value={contact?.birthday}
									onSave={onSaveBirthday}
								/>
							</span>
						</div>
						<div>
							<span><BadgeIcon />CPF</span>
							<span className={!contact?.cpf ? 'empty' : ''}>
								<EditableField
									type="cpf"
									mask="999.999.999-99"
									value={contact?.cpf}
									onSave={onSaveCpf}
								/>
							</span>
						</div>
						<div>
							<span><KeyIcon />Código</span>
							<span className={!contact?.customer_code ? 'empty' : ''}>
								<EditableField
									value={contact?.customer_code}
									onSave={onSaveCustomerCode}
								/>
							</span>
						</div>
					</div>
				</div>
				: <div className="scout-panel__empty">
					Recurso indisponível no seu plano.
				</div>
			}
		</aside>
	)
}

const ConversationProfileSidebarWithBoundary = (props) => (
    <ErrorBoundary
        componentName="ConversationProfileSidebar"
        showReload
        logToBackend
        title="Erro no perfil da conversa"
        message="Ocorreu um erro ao exibir o perfil do contato. Tente novamente."
    >
        <ConversationProfileSidebar {...props} />
    </ErrorBoundary>
)

export default ConversationProfileSidebarWithBoundary